module["exports"] = [
  "Inc",
  "and Sons",
  "LLC",
  "Group"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/company/suffix.js
 ** module id = 433
 ** module chunks = 0
 **/